import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 24px;
  border-radius: 8px;
  min-width: 600px;
  max-width: 700px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #E5E7EB;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: 1.1rem;
  color: ${COLORS.PRIMARY};
  display: flex;
  align-items: center;
  gap: 8px;

  &:before {
    content: '${props => props.$terminology === 'owner' ? 'Owner' : 'Representative'} History';
    color: ${COLORS.SECONDARY};
    font-weight: 500;
  }

  span {
    &:before {
      content: '|';
      margin: 0 8px;
      color: ${COLORS.SECONDARY};
      font-weight: 400;
    }
  }
`;

export const FirstRowWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const ContentToolbar = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  padding-top: 12px;
  margin-bottom: 16px;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background-color: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: ${COLORS.PRIMARY};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  color: #666;
  &:hover {
    color: #333;
  }
`;

export const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HistoryItem = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 12px 0;
  cursor: pointer;

  &:hover {
    background-color: #F9FAFB;
  }
`;

export const TimelineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;
  min-width: 20px;
`;

export const TimelineDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.$isCurrent ? '#10B981' : '#8B5CF6'};
  border: 2px solid ${props => props.$isCurrent ? '#D1FAE5' : '#EDE9FE'};
  flex-shrink: 0;
`;

export const TimelineLine = styled.div`
  width: 2px;
  flex-grow: 1;
  min-height: 40px;
  background-color: #E5E7EB;
  margin-top: 4px;
`;

export const ManagerInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ManagerName = styled.div`
  font-weight: 500;
  color: #1F2937;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DateRange = styled.div`
  font-size: 13px;
  color: #6B7280;
  margin-top: 2px;
`;

export const CurrentBadge = styled.span`
  background-color: #D1FAE5;
  color: #059669;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 9999px;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 4px;
  margin-left: 12px;
  opacity: 0;
  transition: opacity 0.2s ease;

  ${HistoryItem}:hover & {
    opacity: 1;
  }
`;

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  color: #6B7280;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${props => props.$variant === 'delete' ? '#FEE2E2' : '#F3F4F6'};
    color: ${props => props.$variant === 'delete' ? '#DC2626' : '#1F2937'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
